/**
 * Sent Messages Service
 *
 * Everything the club has sent: bulk emails staff wrote by hand, and the
 * school registration notifications the app sends on its own. Both already
 * land in the same log, so one screen covers them.
 *
 * The list is scoped server-side. An owner sees everything; an admin sees
 * the classes assigned to them plus whatever they sent themselves.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const communicationLogsService = {
  /**
   * A page of sent messages, newest first.
   *
   * @param {Object} params
   * @param {number} [params.skip]
   * @param {number} [params.limit] - server caps this at 100
   * @param {string} [params.status] - pending | sent | failed | delivered | bounced
   * @param {string} [params.communication_type] - email | sms
   * @param {string} [params.class_id]
   * @param {string} [params.start_date] - YYYY-MM-DD
   * @param {string} [params.end_date] - YYYY-MM-DD
   * @returns {Promise<{items: Array, total: number}>}
   */
  async list(params = {}) {
    // Empty strings are how the filter controls say "no filter", and the
    // server would read one as a value to match on.
    const query = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null),
    );

    const { data } = await apiClient.get(API_ENDPOINTS.ADMIN.COMMUNICATION_LOGS, {
      params: query,
    });
    return data;
  },
};

export default communicationLogsService;
